
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

import { PaginacionProps } from "../global/PaginacionInterface";

import { ParteProps } from "../recepcion/ParteInterface";
import { AmparoProps, defaultAmparo } from "../recepcion/AmparoInterface";
import { defaultIrregular, IrregularProps } from "../recepcion/IrregularInterface";
import { defaultPromocion, PromocionProps } from "../recepcion/PromocionInterface";
import { defaultExpediente, ExpedienteProps } from "../recepcion/ExpedienteInterface";
import { defaultFechaAudiencia, FechaAudienciaProps } from "../audiencias/AgendaInterface";
import { defaultUsuarioPoderEnLinea, UsuarioPoderEnLineaProps } from '../admin/UsuarioInterface';
import { defaultDemandaInicial, DemandaInicialProps } from "../recepcion/DemandaInicialInterface";
import { defaultExhortoRecibido, ExhortoRecibidoProps } from "../recepcion/ExhortoRecibidoInterface";

import { NotificacionesProps } from "../notificaciones/NotificacionesInterface";
import { defaultMedioImpugnacion, MedioImpugnacionProps, MedioImpugnacionParams } from "./MedioImpugnacionInterface";

// Definición de defaults

export const defaultAcuerdo: AcuerdoProps = {  
    idAcuerdo:                  0,
    juez:                       '',  
    contenido:                  '',
    documento:                  '',
    observacionesCalificar:     '',
    observaciones:              false,
    oficioso:                   false,
    reservado:                  false,
    promocionIrregular:         false,
    archivoProvisional:         false,
    autorizarExpedienteVirtual: false,
    enviarPromocion:            false,
    citaSentencia:              false,
    interponeRecurso:           false,
    resuelveRecurso:            false,
    interponeIncidente:         false,
    idUsuarioElaboro:           0,
    idEstatus:                  0,
    idTipoAcuerdo:              0,
    tipoAcuerdo:                '',
    idSubTipoAcuerdo:           0,
    subTipoAcuerdo:             '',
    idTipoReservado:            0,
    tipoReservado:              '',
    idPlantilla:                0,
    plantilla:                  '',
    idSentidoFallo:             0,
    sentidoFallo:               '',
    idTipoSentencia:            0,
    tipoSentencia:              '',
    idExpediente:               0,
    expediente:                 defaultExpediente,
    idIrregular:                0,
    irregular:                  defaultIrregular,
    idAmparo:                   0,
    amparo:                     defaultAmparo,
    idExhortoRecibido:          0,
    exhortoRecibido:            defaultExhortoRecibido,
    idPromocion:                0,
    promocion:                  defaultPromocion,
    idDemandaInicial:           0,
    demandaInicial:             defaultDemandaInicial,
    usuarioPoderEnLinea:        defaultUsuarioPoderEnLinea,
    asignadoMismoUsuario:       false,
    usuarioAsignado:            '',
    usuarioObservaciones:       [],
    notificaciones:             [],
    solicitarFechaAudiencia:    false,
    audiencia:                  defaultFechaAudiencia,
    idMedioImpugnacion:         0,
    medioImpugnacion:           defaultMedioImpugnacion,
    idEtapa:                    0,
    etapa:                      '',
    idSubEtapa:                 0,
    subEtapa:                   '',
    idCitacionSentencia:        0,
}

export const defaultBuscarAcuerdo: BuscarAcuerdoProps = {    
    idAcuerdo: 0,
    nombre: '',
    tipoAcuerdo: '',
}

export const defaultBuscarAcuerdoResponse: BuscarAcuerdoResponse = {
    ...defaultHttpResponse,
    ...defaultBuscarAcuerdo,
}

export const defaultDetalleAcuerdo: DetalleAcuerdoResponse = {
    ...defaultHttpResponse,
    ...defaultAcuerdo,
}

export const defaultNotificacion: NotificacionesProps = {
    idNotificacion:         0,
    idTipoNotificacion:     0,
    tipoNotificacion:       '',
    idFormaNotificacion:    0,
    formaNotificacion:      '',
    idPersona:              0,
    persona:                '',
    idTipoParte:            0,
    tipoParte:              '',
    idDomicilio:            0,
    domicilio:              '',
}

export const defaultNuevoAcuerdo: NuevoAcuerdoResponse = {
    ...defaultHttpResponse,
    idAcuerdo:              '',
}

export const defaultActualizarEstatus: ActualizarEstatusResponse = {
    ...defaultHttpResponse,
    usuarioAsignado:        '',
    asignadoMismoUsuario:   false,
}

export const defaultEnviarPromocion: EnviarPromocionResponse = {
    ...defaultHttpResponse,
    usuarioAsignado:        '',
}

export const defaultGenerarIrregular: GenerarIrregularResponse = {
    ...defaultHttpResponse,
    irregular:              defaultIrregular,
}

export const defaultConsultaAcuerdosPendientes: ConsultaAcuerdosPendientesResponse = {
    currentPageIndex:       0,
    pageCount:              0,
    recordsCount:           0,
    records:                [],
}

// Creación de interfaces

export interface AcuerdoProps {
    idAcuerdo:                  number;
    fecha?:                     Date;
    juez:                       string;
    contenido:                  string;
    documento:                  string;
    observacionesCalificar:     string;
    observaciones:              boolean;
    oficioso:                   boolean;
    reservado:                  boolean;
    promocionIrregular:         boolean;
    archivoProvisional:         boolean;
    autorizarExpedienteVirtual: boolean;
    enviarPromocion:            boolean;
    citaSentencia:              boolean;
    interponeRecurso:           boolean;
    resuelveRecurso:            boolean;
    interponeIncidente:         boolean;
    idUsuarioElaboro:           number;
    idEstatus:                  number;
    idTipoAcuerdo:              number;
    tipoAcuerdo:                string;
    idSubTipoAcuerdo:           number;
    subTipoAcuerdo:             string;
    idTipoReservado:            number;
    tipoReservado:              string;
    idPlantilla:                number;
    plantilla:                  string;
    idSentidoFallo:             number;
    sentidoFallo:               string;
    idTipoSentencia:            number;
    tipoSentencia:              string;
    idExpediente:               number;
    expediente:                 ExpedienteProps;
    idIrregular:                number;
    irregular:                  IrregularProps;
    idAmparo:                   number;
    amparo:                     AmparoProps;
    idExhortoRecibido:          number;
    exhortoRecibido:            ExhortoRecibidoProps;
    idPromocion:                number;
    promocion:                  PromocionProps;
    idDemandaInicial:           number;
    demandaInicial:             DemandaInicialProps;
    usuarioPoderEnLinea:        UsuarioPoderEnLineaProps;    
    usuarioAsignado:            string;
    asignadoMismoUsuario:       boolean;
    usuarioObservaciones:       UsuarioObservacionesProps[];
    notificaciones:             NotificacionesProps[];
    solicitarFechaAudiencia:    boolean;
    audiencia:                  FechaAudienciaProps;
    idMedioImpugnacion:         number;
    fechaRemisionAlzada?:       Date;
    fechaDevolucionAlzada?:     Date;
    medioImpugnacion:           MedioImpugnacionProps;    
    idEtapa:                    number;
    etapa:                      string;
    idSubEtapa:                 number;
    subEtapa:                   string;
    fechaResolucionAmparo?:     Date;    
    idCitacionSentencia:        number;
}

export interface DetalleAcuerdoResponse extends HttpResponse, AcuerdoProps { }

export interface GuardarAcuerdoParams { 
    id:                             string;
    contenido:                      string;
    idTipoAcuerdo:                  number;
    idSubTipoAcuerdo:               number;
    idTipoReservado:                number;
    idPlantilla:                    number;
    idUsuarioElaboro:               number;
    observaciones:                  string;
    autorizarExpedienteVirtual:     boolean;
    archivoProvisional:             boolean;
    enviarPromocion:                boolean;
    usuarioPoderEnLinea:            UsuarioPoderEnLineaProps;
    idAutoridadExhortoRecibido:     number;
    idObjetoExhorto:                number;
    idClaseExhorto:                 number;
    promocionIrregular:             boolean;
    interponeRecurso:               boolean;
    resuelveRecurso:                boolean;
    interponeIncidente:             boolean;
    idMedioImpugnacion:             number;
    fechaRemisionAlzada:            string;
    fechaDevolucionAlzada:          string;
    fechaResolucionAmparo:          string;
    idSentidoFallo:                 number;
    medioImpugnacion:               MedioImpugnacionParams;
    idEtapa:                        number;
    idSubEtapa:                     number;
    idTipoSentencia:                number;
    idCitacionSentencia:            number;
    citaSentencia:                  boolean;
    solicitarFechaAudiencia:        boolean;
}

export interface ActualizarEstatusParams { 
    id:                             string;
    idEstatus:                      number;
}

export interface ActualizarEstatusResponse extends HttpResponse { 
    usuarioAsignado:            string;
    asignadoMismoUsuario:       boolean;
}

export interface UsuarioObservacionesProps { 
    usuario:        string;
    puesto:         string;
    observacion:    string;
    fecha?:         Date;
}

export interface GuardarNotificacionesParams {
    idAcuerdo:          number;
    notificaciones:     NotificacionesProps[];
}

export interface NuevoAcuerdoParams {
    idExpediente:       number;
    idIrregular:        number;
    idAmparo:           number;
    idExhortoRecibido:  number;
}

export interface NuevoAcuerdoResponse extends HttpResponse {
    idAcuerdo:          string;
}

export interface AgregarPartesParams {
    idAcuerdo:          number;
    partes:             ParteProps[];
}

export interface EnviarPromocionParams {
    idAcuerdo:          number;
}

export interface EnviarPromocionResponse extends HttpResponse {
    usuarioAsignado:          string;
}

export interface GenerarIrregularParams {
    idAcuerdo:              number;
    idTipoAcuerdo:          number;
    idSubTipoAcuerdo:       number;
}

export interface GenerarIrregularResponse extends HttpResponse {
    irregular:          IrregularProps;
}

export interface ObtenerResolucionesParams {
    idExpediente:       number;
    idTipoSentencia:    number;
    idTipoResolucion:   number;
}

//------------------------------------------------------------------------

export interface BuscarAcuerdoParams {
    idExpediente:           number;
    idIrregular:            number;
    idAmparo:               number;
    idExhortoRecibido:      number;
    idTipoAcuerdo:          number;
    idSubTipoAcuerdo:       number;
    fecha?:                 string;
}

export interface BuscarAcuerdoProps {
    idAcuerdo:      number;
    tipoAcuerdo:    string;
    nombre:         string;
    fecha?:         Date;
}

export interface BuscarAcuerdoResponse extends HttpResponse, BuscarAcuerdoProps { }

//---------------------------------------------------------------------------------------------

export interface ConsultaAcuerdosPendientesParams extends PaginacionProps {
    idAutoridad:                    number;
    idMateria:                      number;
    numeroReferencia:               string;
    idTipoAcuerdo:                  number;
    idSubTipoAcuerdo:               number;
    idUsuarioAsignado:              number;
}

export interface ConsultaAcuerdosPendientesProps {
    idAcuerdo:                      number;
    numeroSeguimiento:              string;
    referencia:                     string;
    noReferencia:                   string;
    tipoTramite:                    string;
    tipoAcuerdo:                    string;
    subTipoAcuerdo:                 string;
    usuarioAsignado:                string;
    idEstatus:                      number;
    estatus:                        string;
    diasTranscurridos:              number;
    fecha?:                         Date;
    expediente:                     ExpedienteProps;
    amparo:                         AmparoProps;
    exhortoRecibido:                ExhortoRecibidoProps;
}

export interface ConsultaAcuerdosPendientesResponse {
    currentPageIndex:               number;
    pageCount:                      number;
    recordsCount:                   number;
    records:                        ConsultaAcuerdosPendientesProps[];
}

export interface DescargarAcuerdosPendientesParams {
    idAutoridad:                    number;
    idMateria:                      number;
    numeroReferencia:               string;
    idTipoAcuerdo:                  number;
    idSubTipoAcuerdo:               number;
    idUsuarioAsignado:              number;
}